export function OfferSlotCounter({ slotsRemaining, completed, total, label, unlimited = false }: { slotsRemaining: number | null; completed: number; total: number | null; label?: string; unlimited?: boolean }) {
  return (
    <div className="offer-campaign-progress-card">
      <span>{label || (unlimited ? 'Unlimited capacity' : total ? `${slotsRemaining} slots left` : 'Slots not loaded')}</span>
      <strong>{unlimited ? `${completed} enrolled` : `${completed} / ${total || '-'}`}</strong>
      {!unlimited && <div className="offer-campaign-progress"><i style={{ width: `${total ? Math.min(100, (completed / total) * 100) : 0}%` }} /></div>}
    </div>
  );
}
